import api from "./Api";

export interface ISaldoInicialLancamento {
    id: number;
    codigoContabil: string;
    descricaoCodigoContabil: string | null;
    dataLancamento: string;
    valorProvisaoRecolher: number | null;
    tipoLancamento: string;
    anoCompetencia: number | null;
    isSaldoInicial: boolean;
    nomeArquivoOrigem: string | null;
}

export interface ISaldoInicialLancamentoFilter {
    page?: number;
    perPage?: number;
    codigoContabil?: string;
}

export interface ISaldoInicialLancamentoPage {
    items: ISaldoInicialLancamento[];
    total: number;
    page: number;
    perPage: number;
    totalPages: number;
}

class GerenciarSaldoInicialService {
    async listar(esteiraId: number, filter: ISaldoInicialLancamentoFilter): Promise<ISaldoInicialLancamentoPage> {
        const params: Record<string, any> = {
            page: filter.page ?? 1,
            perPage: filter.perPage ?? 20,
        };
        if (filter.codigoContabil) params.codigoContabil = filter.codigoContabil;

        const { data } = await api.get<ISaldoInicialLancamentoPage>(
            `GerenciarSaldoInicial/esteira/${esteiraId}/lancamentos`,
            { params }
        );
        return data;
    }

    async desfazerUm(lancamentoId: number): Promise<void> {
        await api.delete(`GerenciarSaldoInicial/lancamento/${lancamentoId}`);
    }

    async desfazerTodos(esteiraId: number, codigoContabil?: string): Promise<void> {
        await api.post(`GerenciarSaldoInicial/esteira/${esteiraId}/desfazer-todos`, null, {
            params: codigoContabil ? { codigoContabil } : undefined,
        });
    }
}

export default new GerenciarSaldoInicialService();
